import clsx from 'clsx'
import { Container } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'components/Filters/FilterPanel/subcomponents/SubButtons/subbuttons.module.scss'
import SubButton from 'components/Filters/FilterPanel/subcomponents/SubButtons/subcomponents/SubButton'
import isEqual from 'lodash/isEqual'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const SubButtons = ({ filterManager = {} }) => {
  const { t } = useTranslation()
  const { filters, configuration, clearFilters, initial } = filterManager
  const [showClearButton, setShowClearButton] = useState(false)
  const breakpoints = useBreakpoint()

  const datePickerNames = useMemo(() => {
    const cfgKey = Object.keys(configuration).find(
      (key) => configuration[key].type === 'datepicker',
    )

    return configuration?.[cfgKey]?.names || []
  }, [configuration])

  const clearIgnoreKeys = useMemo(
    () => Object.keys(configuration).filter((key) => configuration[key].subbutton?.clearIgnore),
    [configuration],
  )

  useEffect(() => {
    setShowClearButton(
      Object.keys(filters ?? {})?.find(
        (filterKey) =>
          ![...datePickerNames, ...clearIgnoreKeys].includes(filterKey) &&
          ((Array.isArray(filters?.[filterKey]) && filters?.[filterKey]?.length > 0) ||
            filters?.[filterKey] !== undefined) &&
          !isEqual(filters?.[filterKey], initial?.[filterKey]),
      ),
    )
  }, [filters, configuration, datePickerNames, initial])

  const showedButtons = useMemo(
    () =>
      Object.keys(configuration ?? {}).filter((filterKey) => {
        const value =
          configuration[filterKey].type === 'from-to selector'
            ? {
                from: filters?.[configuration[filterKey].nameFrom],
                to: filters?.[configuration[filterKey].nameTo],
              }
            : filters?.[filterKey]

        return (
          configuration[filterKey]?.subbutton?.isVisible &&
          configuration[filterKey]?.subbutton.isVisible(value, breakpoints)
        )
      }),
    [filters, breakpoints],
  )

  return (
    showedButtons.length > 0 && (
      <Container display={'flex'} className={styles['subbuttons-filters']}>
        {showedButtons.map((filterKey) => (
          <SubButton
            filterManager={filterManager}
            filterKey={filterKey}
            key={'subbutton-' + filterKey}
          />
        ))}
        {showClearButton && (
          <button
            className={clsx(styles['subbuttons-filter'], styles['subbuttons-filter__clear-button'])}
            onClick={clearFilters}
          >
            {t('common::button_labels.clear')}
          </button>
        )}
      </Container>
    )
  )
}

SubButtons.propTypes = {
  filterManager: PropTypes.object,
  onClearFilter: PropTypes.func,
  onClearFilters: PropTypes.func,
}

export default SubButtons
